import React, { useEffect, useState } from 'react'
import AdminForm from './../components/AdminForm'
import { createAdmin, deleteAdminById, findAdminByPhone, importAdmin } from '../services/admin'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { getUserRole } from '../helpers/Users'
import SaveAdminModal from '../components/Modal/SaveAdminModal'
import DeleteAdminModal from '../components/Modal/DeleteAdminModal'
import { getClientId } from '../services/auth'
import { roles, translations } from '../helpers/roles'

const AdminImport = () => {
  const [doc, setDoc] = useState('')
  const [adminFound, setAdminFound] = useState(false)
  const [iAdmin, setIAdmin] = useState({})
  const [role, setRoles] = useState('')
  const [error, setError] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [modalTitle, setModalTitle] = useState('')
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedAdmin, setSelectedAdmin] = useState(null)

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true)
  }

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
    setSelectedAdmin(null)
  }
  const [admin, setAdmin] = useState({
    roles: []
  })

  const handleRoleChange = (role) => {
    setRoles((prevRoles) => {
      const newRoles = prevRoles.includes(role) ? prevRoles.filter((r) => r !== role) : [...prevRoles, role]
      return newRoles
    })
  }

  const doImport = () => {
    importAdmin(iAdmin._id, role)
      .then(() => {
        setShowModal(true)
        setModalTitle('Sucesso')
        setModalMessage('Atualizado com sucesso!')
      })
      .catch((error) => {
        setModalMessage(`Error saving admin: Already imported`)
        setShowModal(true)
        setModalTitle('Falha')
      })
  }

  async function getAdmin() {
    setError('')
    setAdminFound(false)
    const admin = await findAdminByPhone(doc)
    if (admin.clients.find((c) => c.id === getClientId())) {
      setError('O Admin já está importado')
    } else {
      setIAdmin(admin)
      setAdminFound(true)
    }
  }

  return (
    <div>
      <SaveAdminModal
        showModal={showModal}
        setShowModal={setShowModal}
        modalTitle={modalTitle}
        modalMessage={modalMessage}
      />
      <h1>Importar Admin</h1>
      <div>
        <input
          type="text"
          placeholder="Insira o documento"
          value={doc}
          onChange={(e) => setDoc(e.target.value)}
          className="form-control mb-3"
        />
        <Button variant="primary" onClick={getAdmin}>
          Buscar
        </Button>
        {error && <div className="alert alert-warning mt-3">{error}</div>}
        {adminFound && (
          <div className="mt-4">
            <p>
              {iAdmin.name} | {iAdmin.doc} | {iAdmin.phone}
            </p>
            <div>
              <label>Permissões:</label>
              {roles.map((role) => (
                <div key={role}>
                  <input
                    type="checkbox"
                    value={role}
                    checked={admin.roles.includes(role)}
                    onChange={() => handleRoleChange(role)}
                    id={'role' + translations[role]}
                  />
                  <label>{translations[role]}</label>
                </div>
              ))}
            </div>
            <button className="btn btn-success" onClick={doImport}>
              Importar
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminImport
